"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleCheckboxSchema = exports.default = void 0;
var SingleCheckbox_1 = require("./SingleCheckbox");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(SingleCheckbox_1).default; } });
Object.defineProperty(exports, "SingleCheckboxSchema", { enumerable: true, get: function () { return SingleCheckbox_1.SingleCheckboxSchema; } });
//# sourceMappingURL=index.js.map